export default __webpack_public_path__ + "static/media/pizza-5-comp.c2144f5d.jpg";